import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(_ => ({
  container: {
    padding: '20px',
    width: '100%'
  }
}));

export default useStyles;